import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { isNil } from 'lodash/lang'

const validEnvs = ['production', 'staging']
const initSentry = (Vue) => {
  let dsn = process.env.VUE_APP_SENTRY_DSN
  // XXX: Attempting to force-enable sentry for the frontend for now.
  const shouldInitSentry = !isNil(dsn) && dsn !== 'false' && validEnvs.includes(process.env.NODE_ENV)
  // const shouldInitSentry = !isNil(dsn) && dsn !== 'false'
  if (shouldInitSentry) {
    Sentry.init({
      dsn,
      integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
      ignoreErrors: [
        'Cannot read properties of undefined',
        'Non-Error promise rejection captured with keys: config, errors, status_code',
        'TypeError: undefined is not an object',
        'TypeError: Cannot read properties of null',
        'No matching organization',
        'Failed to update a ServiceWorker for scope',
        'Firebase: Error',
        't.doDelete is not a function',
        'ResizeObserver loop completed with undelivered notifications',
        'Cannot destructure property',
        'NavigationDuplicated'
      ],
      beforeSend(event, hint) {
        // console.log('event', event)
        // console.log('hint', hint)
        // XXX: decide if error goes through to sentry here.
        return event
      }
    })
  }
}

export default initSentry
